import { getRecentBlogPostsFromServerSaga } from './BlogPostSagas'
import { getTopNScoresLeaderboardFromServerSaga, getTopNPlaysLeaderboardFromServerSaga, getTopNNotechartArtistsLeaderboardFromServerSaga, getUserPlaysOverTimeActionFromServerSaga, getUserMaxDifficultyPassesOverTimeActionFromServerSaga, getTopNSongsPerYearLeaderboardFromServerSaga, getTopNSongsPerYearAndMonthLeaderboardFromServerSaga, getTopNChartsPerYearLeaderboardFromServerSaga, getTopNChartsPerYearAndMonthLeaderboardFromServerSaga, getUserScoresTakenLeaderboardFromServerSaga, getUserSeasonsProgressActionFromServerSaga, getUserRecommendedRivalsActionFromServerSaga, getUserNextScoresToTakeFromServerSaga, getUserPackProgressActionFromServerSaga, getUserPlaysPerTimeOfDayActionFromServerSaga, getTopNPlaysByCountryLeaderboardFromServerSaga } from './StatsSagas'
import { logInToServerSaga, logInUserLocallySaga, logOutUserSaga } from './LogInSagas'
import { exportUserGdprToServerSaga, getProfileFromServerSaga, getUserCanExportGdprReportFromServerSaga, getUserCanRequestYearInReviewReportFromServerSaga, requestUserYearInReviewReportToServerSaga } from "./ProfileSagas"
import { all, call } from 'redux-saga/effects';

export function* rootSaga() {
    yield all([
        // Disable this because we no longer need/support blog posts after migrating to WordPress.
        // This was originally read from the nopCommerce DB on the server and has since been removed.
        // call(getRecentBlogPostsFromServerSaga),
        call(getTopNScoresLeaderboardFromServerSaga),
        call(getTopNPlaysLeaderboardFromServerSaga),
        call(getTopNNotechartArtistsLeaderboardFromServerSaga),
        call(getTopNChartsPerYearLeaderboardFromServerSaga),
        call(getTopNChartsPerYearAndMonthLeaderboardFromServerSaga),
        call(getTopNSongsPerYearLeaderboardFromServerSaga),
        call(getTopNSongsPerYearAndMonthLeaderboardFromServerSaga),
        call(logInToServerSaga),
        call(logInUserLocallySaga),
        call(logOutUserSaga),
        call(getProfileFromServerSaga),
        call(exportUserGdprToServerSaga),
        call(getUserCanExportGdprReportFromServerSaga),
        call(requestUserYearInReviewReportToServerSaga),
        call(getUserCanRequestYearInReviewReportFromServerSaga),
        call(getUserPlaysOverTimeActionFromServerSaga),
        call(getUserPlaysPerTimeOfDayActionFromServerSaga),
        call(getUserMaxDifficultyPassesOverTimeActionFromServerSaga),
        call(getUserScoresTakenLeaderboardFromServerSaga),
        call(getUserSeasonsProgressActionFromServerSaga),
        call(getUserRecommendedRivalsActionFromServerSaga),
        call(getUserNextScoresToTakeFromServerSaga),
        call(getUserPackProgressActionFromServerSaga),
        call(getTopNPlaysByCountryLeaderboardFromServerSaga),
    ]);
}